import {connectedAtom, connectedSelector} from "../js/ConnectedStore";
import {parseAllActivities, parseAllOccasions} from "./util/app-util";
import {WP_FormSettings} from "../js-backend/state";

export type ActivityID = number|null;
export type OccasionID = number|null;
export type VariantID = number|false; //we use false if no variant needs to/can be selected, and empty array if none was selected yet.

export type Activity = {
	id:ActivityID,
	name:string,
	img:[string,string],
	variants?: {
		[id:number]:string
	},
	
};

export type Occasion = Activity; //for now same data

export const as_allActivities = connectedAtom<Activity[]>({key:'allActStep',default:parseAllActivities()});
export const as_anyActivitySelected = connectedSelector<boolean>({key:'anyActSelected', set:null, get:({get})=>{
	return Object.keys(get(as_result).selectedActivity).length > 0;
}});
export const as_allOccasions = connectedAtom<Occasion[]>({key:'allOccStep',default:parseAllOccasions()});
export const as_anyOccasionSelected = connectedSelector<boolean>({key:'anyOccSelected', set:null, get:({get})=>{
	return Object.keys(get(as_result).selectedOccasion).length > 0;
}});



export type StepData = {
	dispalyedStep:number, //step displayed slider
	readyForNextStep:boolean //if true, the continue button might be displayed.
	isCompleted:boolean,
};
export const as_popupState = connectedAtom<boolean>({key: 'popupstate', default:false});

export const as_frontSortedActivities = connectedAtom<ActivityID[]>({key: 'front_act', default:[]});

export const as_curStepData = connectedAtom<StepData>({key: 'stepdata', default:{
		dispalyedStep:0,
		isCompleted:false,
		readyForNextStep:false
	}});


declare var NeoData: any;
export const as_serverSettings = connectedAtom<WP_FormSettings|null>({key:'formsettings-app',default:NeoData.data.formData })


export enum FormSteps{
	activities,
	occasions,
	location,
	date,
	personal,
}

export type Result = {
	selectedActivity?: {[id:number]:Array<VariantID>}
	selectedOccasion?: {[id:number]:Array<VariantID>}
	city?:string,
	date?:string,
}
export const as_result = connectedAtom<Result|null >({key:'result',default: {
	selectedActivity: {},
	selectedOccasion: {}
} })

export type InitialRequestConfig = {
    data:Result|null
}

/**Values that will be set when popup opens. to allow to preselect certain things like date or city*/
export const as_initialConfig = connectedAtom<InitialRequestConfig >({key:'initialconfig',default: {
    data: {}
} })

export const as_personalDataPageSubmissionHandler = connectedAtom<any>({key:'submission',default:null});


export const as_sendingForm = connectedAtom<boolean>({key:'formsending',default:false});